import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Schedule from '../Schedule/Schedule';
import Games from '../Games/Games';
import Teams from '../Teams';
import Team from '../Teams/Team/Team';
import ViewerEvent from '../Viewer';
import Players from '../Players';
import Account from '../Account';
import Practices from '../Practices';
import Player from '../Players/Player/Player';
import PlayerWrapper from '../Players/Player/PlayerWrapper';
import Profiles from '../Profiles/ProfilesComponent';
import Entities from '../Entities/Entities';
import Monitor from '../Monitor/Monitor';
import Health from '../Health/Health';
import DataOps from '../DataOps/DataOps';
import Customers from '../Customers/Customers';
import AuthorizedRoute from './AuthorizedRoute';
import ProcessingStatus from '../ProcessingStatus/ProcessingStatus';
import { formatDateRoute, isCC } from '../../helpers';
import { useUserState } from '../../store/hooks';

const PrivateAppRoutes = () => {

  const user = useUserState();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const nowDate = new Date();

  return (
    <Switch>
      <Redirect
        exact from={`/`}
        to={isCC(user) || isMobile ? `/schedule/month/${formatDateRoute(nowDate)}` : `/schedule/week/${formatDateRoute(nowDate)}`}
      />
      <Redirect
        exact from={`/schedule`}
        to={isCC(user) || isMobile ? `/schedule/month/${formatDateRoute(nowDate)}` : `/schedule/week/${formatDateRoute(nowDate)}`}
      />
      {isCC(user) && <Redirect from={`/schedule/week`} to={`/schedule/month/${formatDateRoute(nowDate)}`} />}
      <Route path="/schedule/:tab" component={Schedule} />
      <AuthorizedRoute path="/games" component={Games} />
      <AuthorizedRoute path="/teams" component={Teams} />
      <Route path="/team/:conference/:id/:tab/:event" component={Team} />
      <Route path="/account/:tab?" component={Account} />
      <AuthorizedRoute exact path="/practices" component={Practices} />
      <AuthorizedRoute exact path="/players" component={Players} />
      <Route path="/player/:playerId/:event" component={Player} />
      <Route path="/player/:playerId" component={PlayerWrapper} />
      <AuthorizedRoute exact path={'/profiles/:tab?'} component={Profiles} />
      <AuthorizedRoute path={'/entities'} component={Entities} />
      <AuthorizedRoute path={'/status'} component={ProcessingStatus} />
      <Route path="/view/practice/:id/:tab/:subTab/byPeriod/:view/:metric" component={ViewerEvent} />
      <Route path="/view/practice/:id/:tab/:subTab?/:modal?/:playerId?/:modalTab?" component={ViewerEvent} /> {/*
                                                                                    id is gameId,
                                                                                    tab is performance, ball or report,
                                                                                    subtab is condensed or expanded */}
      <AuthorizedRoute path="/view/game/:id/:teamId/:tab/:subTab?/:modal?/:playerId?/:modalTab?" component={ViewerEvent} /> {/*teamId is teamId,
                                                                                    id is gameId,
                                                                                    tab is performance, ball or report,
                                                                                    subtab is condensed or expanded */}
      {/*Command Center*/}
      <AuthorizedRoute path={'/customers/:teamId?/:tab?'} component={Customers} />
      <AuthorizedRoute path={`/monitor/:year/:month/:day`} component={Monitor} />
      <AuthorizedRoute path={`/health/:tab`} component={Health} />
      <AuthorizedRoute path={'/dataops/:page/:gameId?'} component={DataOps} />
      {/*<Route path={'/customers/:teamId?'} component={Customers}/>
      <Route path={`/monitor/:year/:month/:day`} component={Monitor}/>
      <Route path={`/health/:tab`} component={Health}/>
      <Route path={'/dataops'} component={DataOps}/>*/}
      <Redirect from={`*`} to={`/404`} />
    </Switch>
  );
};

export default PrivateAppRoutes;
